import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import { LovableAwareShowHide } from "../LovableFlowControls";

export const ShowHideTable = ({
  showTable: externalShowTable,
  setShowTable: externalSetShowTable,
}) => {
  const [internalShow, setInternalShow, isPDFMode] = usePDFShowHide(false);

  const showTable = isPDFMode
    ? true
    : externalShowTable !== undefined
    ? externalShowTable
    : internalShow;
  const setShowTable = externalSetShowTable || setInternalShow;

  const handleToggle = () => {
    if (!isPDFMode) {
      setShowTable(!showTable);
    }
  };

  return (
    <LovableAwareShowHide
      isOpen={showTable}
      onToggle={handleToggle}
      legacyShowSrc={showIcon}
      legacyHideSrc={hideIcon}
      size="md"
      imgClassName="show-hide-table-icon"
      disabled={isPDFMode}
    />
  );
};
